module.exports = __webpack_public_path__ + "img/timeline_bg_animated.7f2420b9.svg";